import {Link} from "react-router-dom";
import { siteContent } from "../../data/siteContent";

const publicUrl = process.env.PUBLIC_URL || "";

const NavTwo = ({ onItemClick } = {}) => {
    return (
        <ul className="mainmenu">
            {siteContent.nav.map((item) => (
                <li key={item.href}>
                    {item.href.startsWith("/#") ? (
                        (() => {
                            const resolvedHref = `${publicUrl}${item.href}`;
                            return (
                                <a href={resolvedHref} onClick={onItemClick || undefined}>
                                    {item.label}
                                </a>
                            );
                        })()
                    ) : typeof item.href === "string" && item.href.startsWith("http") ? (
                        <a
                            href={item.href}
                            target="_blank"
                            rel="noreferrer"
                            onClick={onItemClick || undefined}
                        >
                            {item.label}
                        </a>
                    ) : (
                        <Link to={item.href} onClick={onItemClick || undefined}>
                            {item.label}
                        </Link>
                    )}
                </li>
            ))}
        </ul>
    )
}
export default NavTwo;
